export const TestHooks = {
	UpdateFileTypeSelect: 'update-file-type-select',
	UpdateSubTypeSelect: 'update-sub-type-select',
	RemoveIcon: 'remove-icon',
	FileTypeOption: 'file-type-option',
	SubTypeOption: 'sub-type-option',
} as const;
